import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { createSvgIcon } from "@mui/material";
const Icon = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11 4a7 7 0 0 1 5.386 11.472l3.089 3.089-1.414 1.414-3.161-3.161A7 7 0 1 1 11 4m0 2a5 5 0 1 0 0 10 5 5 0 0 0 0-10",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon = createSvgIcon(Icon(), "Search");
function Search({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Search$1 = forwardRef(Search);
export {
  Search$1 as S
};
